import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';

/* global customElements */
class PluginGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var pluginGrid = this;
		setTimeout(function(){
			pluginGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var pluginGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'import',
					theme: 'primary',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_SYSTEM:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:upload', ' Import Plugin')
					],
					listeners: {
						click: function() {							
							actionImport();
						}
					}
				},									
				{
					tag: 'dl-action-button',
					itemid: 'control',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_SYSTEM:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Control')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:refresh"></vaadin-icon> Restart',
								listeners: {
									click: function(event) {
										actionRestart(grid.selectedItems[0]);
									}
								}
							},							
							{
								tag: 'hr'
							},							
							{
								tag: 'vaadin-item',
								itemid: 'pluginStart',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:play"></vaadin-icon> Start',
								listeners: {
									click: function(event) {
										actionStart(grid.selectedItems[0]);	
									}
								}
							},
							{
								tag: 'vaadin-item',
								itemid: 'pluginStop',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:stop"></vaadin-icon> Stop',
								listeners: {
									click: function(event) {
										actionStop(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:arrow-backward"></vaadin-icon> Rollback',
								listeners: {
									click: function(event) {
										actionRollback(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:download"></vaadin-icon> Download',
								listeners: {
									click: function(event) {
										actionDownload(grid.selectedItems[0]);
									}
								}
							}							
						]
					}
				},									
				{
					tag: 'dl-action-button',
					itemid: 'uninstall',
					theme: 'error primary',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Uninstall')
					],
					listeners: {
						click: function() {
							actionUninstall(grid.selectedItems[0]);
						}
					}
				}			
			]
		});		

		var syncPluginControlMenuItems = function(record) {
			var controlBtn = ElementUtil.query(toolbar, 'control');
			if (!controlBtn || controlBtn.disabled || !record) {
				return;
			}
			var startItem = ElementUtil.query(controlBtn, 'pluginStart');
			var stopItem = ElementUtil.query(controlBtn, 'pluginStop');
			var stopped = record.adminStatus === 'Stopped';
			if (startItem) {
				startItem.disabled = !stopped;
			}
			if (stopItem) {
				stopItem.disabled = stopped;
			}
		};
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'name',
					header: 'Name',					
					width: '9em',
					renderer: function(root, column, rowData) {
						if (rowData.item.sharedOverride) {
							root.style.backgroundColor = '#77bf77';
						} else {
							root.style.backgroundColor = '';
						}
						root.innerHTML = rowData.item.name;
					}
				},
				{						
					path: 'version',
					header: 'Version',					
					width: '9em'
				},				
				{						
					path: 'description',
					header: 'Description',						
					'flex-grow': '1'						
				},
				{						
					path: 'pluginRuntimeState',
					header: 'Status',
					'text-align': 'center',
					width: '9em'
				},
				{
					path: 'adminStatus',
					header: 'Admin Status',
					'text-align': 'center',
					width: '9em'
				},
				{
					path: 'lastModified',
					header: 'Last Modified',					
					width: '9em',
					renderer: function(root, column, rowData) {						
						var date = TimeUtil.parseDate(rowData.item.lastModified);						
						if (date.getFullYear() < (new Date()).getFullYear() - 10) { 
							root.innerHTML = 'N/A';				
						} else {
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}					
				},
				{						
					path: 'coreModule',
					header: 'Core Module',
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'location',
					header: 'Location',					
					width: '9em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {						
						ElementUtil.query(toolbar, 'control').disabled = false; 
						ElementUtil.query(toolbar, 'uninstall').disabled = false;
						syncPluginControlMenuItems(grid.selectedItems[0]);
					} else {						
						ElementUtil.query(toolbar, 'control').disabled = true;
						ElementUtil.query(toolbar, 'uninstall').disabled = true;
					}	
				}
			}
		});		
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		pluginGrid.append(flexLayout);				
		
		var actionRefresh = function() {
			var loadMask = grid.showLoading();
			Service.getPluginService().getPlugins().then(function(data){
				loadMask.remove();
				grid.activeItem = null;
				
				grid.items = data;
				});
			
		};
		actionRefresh();
		
		var actionImport = function() {
		
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Upload Plugin',
				icon: 'vaadin:upload',
				width: 450,
				height: 220,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A plugin jar is required.');
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 1,
										required: true,
										target: '/api/resource/plugins',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														(responseData.uploadFileType ? responseData.uploadFileType : '')
													);
												} else {
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});
			
		};
		
		var actionStop = function(record) {
			var loadMask = grid.showLoading('Stopping plugin...');
			
			Service.getPluginService().pluginStop(record.pluginId).then(function() {
				loadMask.remove();
				actionRefresh();					
			});			
		};

		var actionRestart = function(record) {
			var loadMask = grid.showLoading('Restarting plugin...');

			Service.getPluginService().pluginRestart(record.pluginId).then(function() {
				loadMask.remove();
				actionRefresh();
			});
		};
		
		var actionRollback = function(record) {
			
			if (!record.sharedOverride) {
				window.DL.MessageUtil.showOkMessage('<h3>Unable to Rollback</h3>This plugin is not overriden and is part of the package.');
			} else {
				window.DL.MessageUtil.showConfirm({
					title: 'Confirm Rollback of Override',
					message: 'Are you sure you want to rollback plugin: ' + record.name + ' ?',
					buttons: [
						{
							text: 'Yes',
							handler: function() {
								var loadMask = grid.showLoading('Rollingback plugin...');													

								Service.getPluginService().pluginRollback(record.pluginId).then(function(result){
									loadMask.remove();
									if (result.success) {
										window.DL.MessageUtil.showToast('Success', 'Rolledback: ' + record.name, {									
											theme: 'success'
										});
									} else {
										window.DL.MessageUtil.showToastError(result.data, 'Rollback Failed');
									}								
									actionRefresh();
								});															

							}	
						},
						{
							text: 'No'
						}
					]
				});							
			}
		
		};

		var actionStart = function(record) {
			var loadMask = grid.showLoading('Starting plugin...');
			
			Service.getPluginService().pluginStart(record.pluginId).then(function() {
				loadMask.remove();
				actionRefresh();					
			});	
		};

		var actionDownload = function(record) {
			Service.getPluginService().downloadPlugin(record.pluginId);
		};
		
		var actionUninstall = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Uninstall',
				message: 'Are you sure you want to uninstall plugin: ' + record.name + ' ? <br><br> (Some functionality may be unavailable with the plugin removed.)',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Uninstalling plugin...');													
							
							Service.getPluginService().uninstallJob(record.pluginId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Uninstalled ' + record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});			
			
		};		
		
	}
	
};
customElements.define('dl-plugin-grid', PluginGrid);

